import React from 'react'
import RoomFacilitesDetailTable from './Components/RoomFacilitesDetailTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const RoomFacilitiesDetailList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Room Facilites Detail</HeadingOne>
          <AddItemBtn url="add-room-facilites-detail" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <RoomFacilitesDetailTable />
      </div>
    </PageBody>
  );
};

export default RoomFacilitiesDetailList;
